{
  "heading": "Collection",
  "tabs": {
    "label": "Collection views",
    "cards": "Cards",
    "animes": "Works"
  },
  "media": {
    "anime": "Anime",
    "manga": "Manga",
    "novel": "Novel",
    "videoGame": "Video game",
    "cinematography": "Cinematography",
    "work": "Work"
  },
  "filters": {
    "title": "Filters",
    "button": "Filters",
    "reset": "Reset",
    "sort": "Sort",
    "sortBy": "Sort by",
    "display": "Display",
    "all": "All",
    "show": "Show"
  },
  "binder": {
    "search": "Search for a character, title, or tag",
    "purge": "Purge",
    "purgeCards": "Purge cards",
    "fragments": "Fragments",
    "fragmentsCards": "Upgrade cards",
    "favoritesOnly": "Favorites only",
    "wishFailed": "Couldn’t update wishlist",
    "showCards": "Show cards",
    "openBooster": "Open a booster",
    "noMatch": "No cards match",
    "noMatchHint": "Change the search or the filters.",
    "empty": "Your binder is empty",
    "missingHint": "Missing characters appear as silhouettes on each <anime>work</anime> page.",
    "summary": "{{characters}}, {{fragments}}, {{animes}}.",
    "characters_one": "{{formatted}} character",
    "characters_other": "{{formatted}} characters",
    "characters_many": "{{formatted}} characters",
    "fragments_one": "{{formatted}} fragment in reserve",
    "fragments_other": "{{formatted}} fragments in reserve",
    "fragments_many": "{{formatted}} fragments in reserve",
    "animes_one": "{{formatted}} completed work",
    "animes_other": "{{formatted}} completed works",
    "animes_many": "{{formatted}} completed works",
    "sorts": {
      "recent": "Recently obtained",
      "popularity": "Popularity",
      "nametag": "Tag",
      "rarity": "Rarity",
      "fragments": "Fragments",
      "level": "Level",
      "name": "Name",
      "attack_desc": "Attack (high → low)",
      "attack_asc": "Attack (low → high)",
      "defense_desc": "Defense (high → low)",
      "defense_asc": "Defense (low → high)"
    }
  },
  "animes": {
    "intro": "Rank depends on the work’s popularity, from F to EX. Complete a series by obtaining every character.",
    "searchPlaceholder": "Search for a work",
    "searchLabel": "Search for a work",
    "rankFilter": "Filter by rank",
    "allRanks": "All ranks",
    "rank": "Rank",
    "rankOption": "Rank {{rank}}",
    "showAnimes": "Show works",
    "progress": "{{title}} progress",
    "emptyTitle": "No works found",
    "emptyBody": "The catalog fills in as it syncs.",
    "emptyFilteredTitle": "Nothing here yet",
    "emptyFilteredBody": "Open boosters to start series.",
    "views": {
      "all": "All",
      "owned": "Started",
      "completed": "Completed"
    },
    "sorts": {
      "popularity": "Popularity",
      "progress": "Progress",
      "title": "Title",
      "characters": "Most characters",
      "divine": "Most Divine",
      "mythic": "Most Mythic",
      "legendary": "Most Legendary",
      "epic": "Most Epic",
      "rare": "Most Rare",
      "uncommon": "Most Uncommon",
      "common": "Most Common"
    }
  },
  "series": {
    "back": "Works",
    "cover": "cover",
    "banner": "banner",
    "progress": "Series progress",
    "complete": "Series complete",
    "rewards": {
      "title": "Completion reward",
      "booster": "{{charges}} × {{name}}",
      "earned": "Already claimed"
    },
    "shown": "Characters shown",
    "favourites_one": "{{formatted}} favorite",
    "favourites_other": "{{formatted}} favorites",
    "favourites_many": "{{formatted}} favorites",
    "obtained_one": "{{owned}} / {{total}} character obtained",
    "obtained_other": "{{owned}} / {{total}} characters obtained",
    "obtained_many": "{{owned}} / {{total}} characters obtained",
    "sort": "Sort",
    "sorts": {
      "rarity": "Rarity",
      "attack_desc": "Attack (high → low)",
      "attack_asc": "Attack (low → high)",
      "defense_desc": "Defense (high → low)",
      "defense_asc": "Defense (low → high)"
    },
    "show": {
      "all": "All",
      "owned": "Obtained",
      "missing": "Missing"
    },
    "noMissing": "No missing characters",
    "noMissingHint": "You’ve completed this series.",
    "noneOwned": "No characters obtained",
    "noneOwnedHint": "Boosters can contain characters from this series.",
    "favoriteFailed": "Couldn’t update favorite",
    "wishFailed": "Couldn’t update wishlist"
  },
  "purge": {
    "actions": "Sell selected cards",
    "selected_one": "{{count}} card",
    "selected_other": "{{count}} cards",
    "title": "Purge",
    "intro": "The system buys cards back at 10% of their value. 5% of that amount goes into the jackpot. Tap the star to keep a character: a favorite can’t be sold.",
    "rarityGroup": "Purge an entire rarity",
    "search": "Search for a character or a title",
    "empty": "No cards to purge",
    "emptyHint": "Favorites and locked cards stay in your collection.",
    "tooLow": "Too low",
    "selling": "Selling…",
    "sell": "Sell to the system",
    "rarityFailed": "Rarity unavailable",
    "none": "No {{rarity}} cards to purge",
    "noneHint": "Favorites and locked cards stay.",
    "favoriteFailed": "Couldn’t update favorite",
    "sold": "Purge sold",
    "failed": "Couldn’t purge",
    "confirm": "Sell {{cards}} to the system for {{anima}}? They leave your collection. Favorites stay.",
    "soldDetail": "{{cards}} · {{anima}}",
    "cards_one": "{{formatted}} card",
    "cards_other": "{{formatted}} cards",
    "cards_many": "{{formatted}} cards",
    "anima": "{{formatted}} Anima"
  },
  "fragments": {
    "actions": "Upgrade and convert fragments",
    "title": "Fragments",
    "intro": "10 levels to make a card your own. Each upgrade unlocks a customization and new reflections. Select cards to upgrade them by one level.",
    "levelGuide": "Levels open the workshop",
    "levelGuideHint": "Open a card’s details to preview its milestones and personalize unlocked options.",
    "conversionHint": "Only fragments on level 10 cards can be converted into Anima. Fragments on former level 5 cards remain available for the new milestones.",
    "search": "Search for a character or a title",
    "rarity": "Filter by rarity",
    "allRarities": "All rarities",
    "selectPage": "Select all",
    "empty": "No card to upgrade",
    "emptyHint": "Open boosters and recycle duplicates to earn fragments.",
    "step": "Lv. {{level}} · {{fragments}}",
    "notEnough": "Not enough fragments",
    "maxed": "Awakened · 10/10",
    "convertValue": "+{{anima}} Anima",
    "convertSpare": "Melt unused fragments into Anima",
    "converting": "Melting…",
    "confirmConvert": "Melt the fragments of every maxed card into Anima?",
    "converted": "Fragments melted",
    "convertedDetail": "{{cards}} cards emptied: {{fragments}} fragments → {{anima}} Anima.",
    "stashTitle": "Reserved fragments",
    "stashTotal": "{{fragments}} waiting",
    "stashIntro": "Earned from quests, achievements or sales: they join the card as soon as you obtain the character.",
    "stashEmpty": "No reserved fragments yet.",
    "stashCount": "{{fragments}} fragments",
    "stashTruncated": "{{entries}} more characters also hold reserved fragments.",
    "upgraded": "Upgrades applied",
    "upgradedDetail": "{{cards}} cards upgraded, {{fragments}} fragments spent.",
    "failed": "Couldn’t upgrade",
    "upgrading": "Upgrading…",
    "upgradeSelection": "Upgrade ({{cards}})",
    "upgradeAll": "Upgrade all",
    "confirmSelection": "Upgrade {{cards}} card(s) by one level?",
    "confirmAll": "Upgrade every card that can afford it by one level?"
  },
  "detail": {
    "fallbackTitle": "Card",
    "upgraded": "Card upgraded to level {{level}}",
    "unlocked": "Unlocked: {{unlock}}",
    "upgradeFailed": "Couldn’t upgrade",
    "favourites": "Favorites",
    "referenceValue": "Reference value",
    "attack": "Attack",
    "defense": "Defense",
    "role": "Role",
    "obtainedOn": "Obtained",
    "copies": "Copies obtained",
    "lock": "Lock",
    "locks": {
      "listing": "For sale",
      "auction": "In auction",
      "trade": "In a trade"
    },
    "stashed": "Fragments set aside",
    "upgrade": "Upgrade",
    "levelOf": "Level {{level}} of {{max}}",
    "fragmentMeter": "Fragments toward the next upgrade",
    "fragmentCount_one": "{{owned}} / {{cost}} fragment",
    "fragmentCount_other": "{{owned}} / {{cost}} fragments",
    "fragmentCount_many": "{{owned}} / {{cost}} fragments",
    "upgradeHint": "Unlocks: {{unlock}}. Each {{rarity}} duplicate gives {{fragments}}.",
    "fragmentYield_one": "{{count}} fragment",
    "fragmentYield_other": "{{count}} fragments",
    "fragmentYield_many": "{{count}} fragments",
    "maxReached": "Awakened card: all 9 customizations are available.",
    "missing": "Not in your collection yet. This {{rarity}} character can come from any booster that offers this rarity.",
    "removeFavorite": "Remove from favorites",
    "addFavorite": "Add to favorites",
    "favoriteFailed": "Couldn’t update favorite",
    "addWish": "Add to wishlist",
    "removeWish": "Remove from wishlist",
    "wishHint": "You’ll be notified if it is listed for sale or auction.",
    "wishFailed": "Couldn’t update wishlist",
    "nametag": "Personal tag",
    "nametagPlaceholder": "e.g. JOJO",
    "nametagHint": "Reuse the same tag to group multiple characters.",
    "saveNametag": "Save tag",
    "nametagSaved": "Tag updated",
    "nametagFailed": "Couldn’t update tag",
    "avatarUpdated": "Avatar updated",
    "useAvatar": "Use as avatar",
    "share": "Share",
    "linkCopied": "Link copied",
    "copyLink": "Copy public link",
    "sell": "Sell",
    "upgradeTo": "Upgrade to level {{level}}"
  },
  "workshop": {
    "title": "Card workshop",
    "cardInfo": "Card information",
    "evolution": "Evolution",
    "customize": "Customize",
    "levels": "The card’s 10 levels",
    "previewHint": "Tap a level to try its appearance without spending fragments.",
    "previewLevel": "Level {{level}} preview · not applied",
    "backToCard": "Back to my card",
    "unsaved": "Unsaved customization",
    "reached": "Unlocked",
    "notReached": "Locked",
    "next": "Next milestone",
    "previewOnly": "Preview only",
    "stepCost": "{{cost}} fragments from the previous level",
    "costShort": "{{cost}} fragments",
    "nextUpgrade": "Next upgrade · level {{level}}",
    "useUnlock": "Use this option",
    "allUnlocks": "See all 10 milestones",
    "ready": "You’re ready for the next level.",
    "remaining_one": "{{formatted}} more fragment for this milestone.",
    "remaining_other": "{{formatted}} more fragments for this milestone.",
    "remaining_many": "{{formatted}} more fragments for this milestone.",
    "duplicateYield_one": "Each duplicate gives this card {{count}} fragment.",
    "duplicateYield_other": "Each duplicate gives this card {{count}} fragments.",
    "duplicateYield_many": "Each duplicate gives this card {{count}} fragments.",
    "atLevel": "Level {{level}}",
    "automatic": "Auto",
    "customizeHint": "Changes preview live on your card. Save to keep them.",
    "lockedCard": "Remove this card from its sale, auction or trade to change its appearance.",
    "nicknameHint": "The real name stays visible so the character can be recognized. {{max}} characters maximum.",
    "signaturePlaceholder": "e.g. My first favorite",
    "signatureHint": "A short message at the foot of your card. {{max}} characters maximum.",
    "transferHint": "Your appearance is personal: it doesn’t transfer with a sale or trade. The level is preserved.",
    "save": "Save card style",
    "saving": "Saving…",
    "saved": "Card style saved",
    "saveFailed": "Couldn’t save card style",
    "invalidText": "Remove line breaks and invisible characters, then try again.",
    "cancel": "Cancel",
    "features": {
      "nickname": "Nickname",
      "nameColor": "Name color",
      "frame": "Border",
      "emblem": "Emblem",
      "haloColor": "Halo color",
      "finish": "Finish",
      "signature": "Signature",
      "aura": "Aura",
      "portrait": "Portrait framing"
    },
    "colors": { "ice": "Ice", "cyan": "Lagoon", "gold": "Gold", "rose": "Rose", "mint": "Mint", "violet": "Lilac", "peach": "Peach" },
    "frames": { "precision": "Etched", "duo": "Double", "ornate": "Ornament" },
    "emblems": { "star": "Star", "heart": "Heart", "moon": "Moon", "flame": "Flame", "crown": "Crown", "sword": "Sword" },
    "finishes": { "silk": "Silk", "prism": "Prism", "starlight": "Stardust" },
    "auras": { "orbit": "Orbit", "petals": "Petals", "constellation": "Constellation" },
    "portraits": { "original": "Original", "closeup": "Close-up", "cinematic": "Cinematic" },
    "descriptions": {
      "1": "The original portrait and its rarity’s identity. Your story with this card starts here.",
      "2": "Give your character a nickname without hiding its real name.",
      "3": "Choose one of 7 name colors to add your own touch.",
      "4": "An etched, double or ornate border around the portrait.",
      "5": "Add a star, heart, moon, flame, crown or sword.",
      "6": "Choose the halo color independently of the card’s rarity.",
      "7": "A silk finish, an iridescent prism or a dusting of stars.",
      "8": "Add a short personal message beneath the name and title.",
      "9": "Animate the edges with a glowing orbit, petals or a constellation.",
      "10": "Adjust the portrait framing and reveal the awakened card’s golden seal."
    },
    "fx": {
      "1": "Original appearance",
      "2": "Pearlescent touch reflections",
      "3": "Luminous facets",
      "4": "Etched outlines",
      "5": "Medallion and metallic edges",
      "6": "Glowing halo",
      "7": "Holographic veil",
      "8": "Collector’s inscription",
      "9": "Aura particles",
      "10": "Golden seal and awakened frame"
    }
  },
  "share": {
    "shared": "Card shared",
    "failed": "Couldn’t share",
    "title": "Share {{name}}",
    "linkCopied": "Public link copied",
    "copyLink": "Copy public link",
    "noFriends": "No friends",
    "noFriendsHint": "Add friends to share this card in a message."
  },
  "card": {
    "notOwned": "not obtained yet",
    "owned": "obtained",
    "level": "level {{level}}",
    "fragments_one": "{{count}} fragment",
    "fragments_other": "{{count}} fragments",
    "fragments_many": "{{count}} fragments",
    "levelShort": "Lv. {{level}}",
    "locked": "Card locked",
    "favoriteRemove": "Remove {{name}} from favorites",
    "favoriteAdd": "Add {{name}} to favorites",
    "wishRemove": "Remove {{name}} from wishlist",
    "wishAdd": "Add {{name}} to wishlist",
    "attack": "Attack",
    "defense": "Defense",
    "combat": "attack {{attack}}, defense {{defense}}"
  }
}
